import type { Phenomenon, PhenomenonState } from '@protector/entities/phenomenon/models';
import { INITIAL_PAGE_V4 } from '@protector/utils/constants';
import type { SimplePhenomena } from '@protector/utils/types';
import { getNameByCurrentLanguage } from 'core/utils/functions';
import type { EntityAdapter } from 'redux-ngrx-entity';
import { createEntityAdapter } from 'redux-ngrx-entity';
import { createSelector } from 'reselect';
import type { AppState } from '../../redux/app-state';
import * as PhenomenonActions from './phenomenon.actions';

const { PhenomenonActionsTypes } = PhenomenonActions;

type PhenomenonActionsFunctions = Omit<typeof PhenomenonActions, 'PhenomenonActionsTypes'>;
type ActionsResponses = ReturnType<PhenomenonActionsFunctions[keyof PhenomenonActionsFunctions]>;

function selectPhenomenonUuid(phenomenon: Phenomenon): string {
  return phenomenon.id;
}

// function sortByName(a: Phenomenon, b: Phenomenon): number {
//   return a.name.localeCompare(b.name);
// }

const entity: EntityAdapter<Phenomenon> = createEntityAdapter<Phenomenon>({
  selectId: selectPhenomenonUuid
  // sortComparer: sortByName,
});

const initialState = entity.getInitialState<PhenomenonState>({
  ids: [],
  entities: {},
  page: {
    ...INITIAL_PAGE_V4
  },
  isLoading: false,
  error: null,
  isLoadingMethodology: false,
  methodology: null
});

export default (state = initialState, action: ActionsResponses) => {
  switch (action.type) {
    case PhenomenonActionsTypes.LOAD_PHENOMENON_BY_METHODOLOGY:
      return {
        ...state,
        isLoading: false
      };
    case PhenomenonActionsTypes.LOAD_PHENOMENON_BY_METHODOLOGY_SUCCESS:
      return entity.upsertMany(action.payload, {
        ...state,
        page: {
          ...action.payload
        },
        isLoading: false,
        error: null
      });
    case PhenomenonActionsTypes.LOAD_METHODOLOGY:
      return {
        ...state,
        isLoadingMethodology: true,
        error: null,
        methodology: null
      };
    case PhenomenonActionsTypes.LOAD_METHODOLOGY_SUCCESS:
      return {
        ...state,
        isLoadingMethodology: false,
        methodology: action.payload
      };
    case PhenomenonActionsTypes.LOAD_METHODOLOGY_FAILURE:
      return {
        ...state,
        isLoadingMethodology: false,
        error: action.payload
      };
    default:
      return state;
  }
};

const { selectAll } = entity.getSelectors();
export const selectAllPhenomenons = selectAll;

export const getSimplePhenomena = createSelector(
  (state: AppState) => selectAllPhenomenons(state.entities.phenomenon),
  (phenomena: Phenomenon[]) => {
    return phenomena.map<SimplePhenomena>((phenomenon: Phenomenon) => {
      return {
        id: phenomenon.id,
        name: phenomenon.name,
        short_description: phenomenon.short_description,
        category: getNameByCurrentLanguage(phenomenon.category.name),
        methodologyId: phenomenon.methodologyIds ? phenomenon.methodologyIds[0] : '',
        companyId: phenomenon.company_id
      };
    });
  }
);
